import React from "react";
import { connectStateResults } from "react-instantsearch-dom";

type HasNoHitsProps = {
  searchResults?: { nbHits: number };
  children?: React.ReactNode;
};

// Show wrapped content only if there are any search hits
const HasNoHits: React.FunctionComponent<any> = (props): JSX.Element | null => {
  const { searchResults, children }: HasNoHitsProps = props;
  const hasNoResults = searchResults && searchResults.nbHits === 0;

  if (hasNoResults) {
    return <>{children}</>;
  }
  return null;
};

export default connectStateResults(HasNoHits);
